import React from 'react';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';
import Head from 'next/head';
import { getTitles } from '@src/containers/Session/selectors/getTitles';
import { getTotalCount } from '@src/containers/SpacesListing/selectors/getTotalCount';
import { getListingDefaultTitle } from '@src/containers/SpacesListing/selectors/getListingDefaultTitle';
import { getListingDefaultDescription } from '@src/containers/SpacesListing/selectors/getListingDefaultDescription';

const SeoHeadCDefault = () => {
	const seo = useSelector(getTitles);
	const count = useSelector(getTotalCount);
	const router = useRouter();
	const {
		query: { town, seo_slug },
	} = router;
	const targetCanonical = seo_slug
		? `https://spotlyst.ru/${town}/${seo_slug}/`
		: `https://spotlyst.ru/${town}/`;

	const canonical = <link rel="canonical" href={targetCanonical} />;
	const isNoIndex = !seo.title || count === 0 || seo.isNoIndex;

	const defaultTitle = useSelector(getListingDefaultTitle);
	const defaultDescription = useSelector(getListingDefaultDescription);

	const title = seo.title || defaultTitle;
	const description = seo.description || defaultDescription;

	return (
		<Head>
			{canonical}
			{isNoIndex && <meta name="robots" content="noindex" />}
			<title>{title}</title>
			<meta name="description" content={description} key="description" />
			{seo.keyword && (
				<meta name="keywords" content={seo.keyword} key="keywords" />
			)}
		</Head>
	);
};

export default SeoHeadCDefault;
